var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { DATA_ATTRIBUTES, DATA_HOOKS } from './constants';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown';
import classnames from 'classnames';
import { TPAComponentsContext } from '../TPAComponentsConfig';
import { st as buttonSt } from '../Button/Button.st.css';
import { st, classes } from './DropdownNativeSelect.st.css';
var DropdownNativeSelectComponent = /** @class */ (function (_super) {
    __extends(DropdownNativeSelectComponent, _super);
    function DropdownNativeSelectComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownNativeSelectComponent.prototype.onSelect = function (e) {
        var prevSelectedOption = this.props.selectedOption;
        var optionId = e.target.value;
        if ((prevSelectedOption && prevSelectedOption.id) === optionId) {
            return;
        }
        var selectedOption = this.props.options.find(function (_a) {
            var id = _a.id;
            return id === optionId;
        });
        this.props.onSelect(selectedOption);
    };
    DropdownNativeSelectComponent.prototype.renderOptions = function (hasPlaceholder) {
        var _a = this.props, placeholder = _a.placeholder, options = _a.options;
        return (React.createElement(React.Fragment, null,
            hasPlaceholder && (React.createElement("option", { "data-hook": DATA_HOOKS.placeholderOption, value: "", disabled: true }, placeholder)),
            options.map(function (option, i) {
                return !option.divider ? (React.createElement("option", { key: i, value: option.id, disabled: !option.isSelectable }, option.value)) : null;
            })));
    };
    DropdownNativeSelectComponent.prototype.renderOptionIcon = function () {
        return (React.createElement("div", { className: classes.optionIcon }, this.props.selectedOption.icon));
    };
    DropdownNativeSelectComponent.prototype.getDataAttributes = function () {
        var _a;
        var error = this.props.error;
        return _a = {},
            _a[DATA_ATTRIBUTES.error] = error,
            _a;
    };
    DropdownNativeSelectComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, selectedOption = _a.selectedOption, error = _a.error, errorMessage = _a.errorMessage, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], dropdownId = _a.id, className = _a.className, name = _a.name, errorComponent = _a.errorComponent, newErrorMessage = _a.newErrorMessage;
        var rtl = this.context.rtl;
        var hasPlaceholder = !selectedOption || !selectedOption.value;
        var shouldRenderIcon = selectedOption && !!selectedOption.icon;
        var buttonStyle = buttonSt(classes.root, {
            fullWidth: true,
        });
        var nativeSelectStyles = st(classes.root, {
            error: error,
            disabled: disabled,
            placeholder: hasPlaceholder,
            icon: shouldRenderIcon,
            rtl: rtl,
        }, className);
        return (React.createElement("div", { className: classes.wrapper },
            React.createElement("select", __assign({}, this.getDataAttributes(), { defaultValue: "" }, (selectedOption && { value: selectedOption.id }), { id: dropdownId, onChange: function (e) { return _this.onSelect(e); }, "data-hook": DATA_HOOKS.nativeSelect, ref: this.props.innerRef, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, disabled: disabled, name: name, className: classnames(nativeSelectStyles, buttonStyle) }), this.renderOptions(hasPlaceholder)),
            shouldRenderIcon ? this.renderOptionIcon() : null,
            error && errorMessage && !newErrorMessage && errorComponent,
            React.createElement(ChevronDown, { className: classes.arrowIcon })));
    };
    DropdownNativeSelectComponent.contextType = TPAComponentsContext;
    return DropdownNativeSelectComponent;
}(React.Component));
export var DropdownNativeSelect = React.forwardRef(function (props, ref) { return (React.createElement(DropdownNativeSelectComponent, __assign({}, props, { innerRef: ref }))); });
//# sourceMappingURL=DropdownNativeSelect.js.map